import AudioIcon from '@icons/ai-agents/audio-icon';
import ChangeInfoIcon from '@icons/ai-agents/change-info-icon';
import CreateNoteIcon from '@icons/ai-agents/create-note-icon';
import CreatetaskIcon from '@icons/ai-agents/create-task-icon';
import EndIcon from '@icons/ai-agents/end-icon';
import LeadActionIcon from '@icons/ai-agents/lead-action-icon';
import LlmIcon from '@icons/ai-agents/llm-icon';
import QcIcon from '@icons/ai-agents/qc-icon';
import SendMessageIcon from '@icons/ai-agents/send-message-icon';
import StartIcon from '@icons/ai-agents/start-icon';
import TtsIcon from '@icons/ai-agents/tts-icon';

export enum flowChatTypes {
  START = 'START',
  TTS = 'TTS',
  QUESTION_CLASSIFIER = 'QUESTION_CLASSIFIER',
  PLAY_AUDIO = 'PLAY_AUDIO',
  FINISH = 'FINISH',
  SEND_MESSAGE = 'SEND_MESSAGE',
  ACTION = 'ACTION',
  LLM = 'LLM'
}

export const flowChatData = {
  [flowChatTypes.START]: {
    name: 'Boshlanishi',
    description: '',
    width: 331,
    height: 56,
    icon: StartIcon,
    json: {}
  },
  [flowChatTypes.TTS]: {
    name: 'TTS',
    description: '',
    width: 331,
    height: 228,
    icon: TtsIcon,
    json: {
      language: 'uz',
      voice: 'NIGORA',
      speed: 1,
      text: ''
    }
  },
  [flowChatTypes.QUESTION_CLASSIFIER]: {
    name: 'question classifier',
    description: '',
    width: 331,
    height: 174,
    icon: QcIcon,
    json: { prompt: '', inputType: 'NONE', tokenLimit: 0, ai: 'GEMINI', useOldConversation: false }
  },
  [flowChatTypes.PLAY_AUDIO]: {
    name: 'AUDIO',
    description: '',
    width: 331,
    height: 147,
    icon: AudioIcon,
    json: { fileId: null }
  },
  [flowChatTypes.FINISH]: {
    name: 'END',
    description: '',
    width: 331,
    height: 82,
    icon: EndIcon,
    json: {}
  },
  [flowChatTypes.SEND_MESSAGE]: {
    name: 'send text message',
    description: '',
    width: 331,
    height: 216,
    icon: SendMessageIcon,
    json: {
      text: ''
    }
  },
  [flowChatTypes.ACTION]: {
    name: 'Lead action',
    description: '',
    width: 331,
    height: 229,
    icon: LeadActionIcon,
    json: {
      action: 'SET_VALUE',
      createTaskDto: {
        deadLineAfterStatus: 'NOW',
        assignedById: '',
        leadTaskTypeId: '',
        text: ''
      },
      setFieldDto: {
        setField: 'CONTACT_NAME',
        customFieldId: '',
        value: '',
        values: ''
      },
      leadNoteDto: {
        type: 'SIMPLE',
        text: ''
      }
    }
  },
  [flowChatTypes.LLM]: {
    name: 'LLM',
    description: '',
    width: 331,
    height: 254,
    icon: LlmIcon,
    json: {
      prompt: '',
      inputType: 'NONE',
      tokenLimit: 0,
      ai: 'GEMINI',
      useOldConversation: false
    }
  }
};

export const nodeBlockItems = [
  {
    key: 1,
    label: 'TTS',
    icon: TtsIcon,
    nodeType: flowChatTypes.TTS,
    isView: ['CALL']
  },
  {
    key: 3,
    label: 'Audio yuklash',
    icon: AudioIcon,
    nodeType: flowChatTypes.PLAY_AUDIO,
    isView: ['CALL']
  },
  {
    key: 4,
    label: 'Mijoz javobi',
    icon: QcIcon,
    nodeType: flowChatTypes.QUESTION_CLASSIFIER,
    isView: ['MESSAGE']
  },
  {
    key: 6,
    label: 'Send to message',
    icon: SendMessageIcon,
    nodeType: flowChatTypes.SEND_MESSAGE,
    isView: ['MESSAGE']
  },
  {
    key: 7,
    label: 'Lead action',
    icon: LeadActionIcon,
    nodeType: flowChatTypes.ACTION,
    isView: ['CALL', 'MESSAGE']
  },
  {
    key: 8,
    label: 'LLM',
    icon: LlmIcon,
    nodeType: flowChatTypes.LLM,
    isView: ['MESSAGE']
  },
  {
    key: 5,
    label: 'Yakunlash',
    icon: EndIcon,
    nodeType: flowChatTypes.FINISH,
    isView: ['CALL', 'MESSAGE']
  }
];

export const staticFields = [
  {
    setField: 'CONTACT_NAME',
    name: 'kontact ismi'
  },
  {
    setField: 'CONTACT_PHONE',
    name: 'kontact raqami'
  },
  {
    setField: 'LEAD_NAME',
    name: 'lid nomi'
  },
  {
    setField: 'LEAD_RESPONSIBLE',
    name: 'lid masul xodimi'
  },
  {
    setField: 'LEAD_BALANCE',
    name: 'lid balansi'
  },
  {
    setField: 'LEAD_PIPE_STATUS',
    name: 'lid varonka etapi'
  }
];

export const actionOptions = [
  {
    key: '1',
    value: 'SET_VALUE',
    label: 'malumotlarni_ozgartirish',
    icon: ChangeInfoIcon
  },
  {
    key: '2',
    value: 'CREATE_TASK',
    label: 'topshiriq_yaratish',
    icon: CreatetaskIcon
  },
  {
    key: '3',
    value: 'CREATE_NOTE',
    label: 'eslatma_yozish',
    icon: CreateNoteIcon
  }
];

export const deadlineDates = [
  {
    key: '1',
    label: 'NOW',
    value: 'NOW'
  },
  {
    key: '2',
    label: 'END_OF_DAY',
    value: 'END_OF_DAY'
  },
  {
    key: '3',
    label: 'AFTER_DAY',
    value: 'IN_1_DAY'
  },
  {
    key: '4',
    label: 'IN_3_DAYS',
    value: 'IN_3_DAYS'
  },
  {
    key: '5',
    label: 'END_OF_WEEKEND',
    value: 'END_OF_WEEKEND'
  },
  {
    key: '6',
    label: 'BASE_ON_CONVERSATION',
    value: 'BASE_ON_CONVERSATION'
  }
];

export const aiResultStatus = {
  IN_PROGRESS: {
    color: '#17A2B8',
    bg: '#E0F7FA',
    label: 'home.Jarayonda'
  },
  ERROR_OCCURRED: {
    color: '#DC3545',
    bg: '#F8D7DA',
    label: 'home.Xatolik topildi'
  },
  FINISHED: {
    color: '#28A745',
    bg: '#E9F7EF',
    label: 'calendar_view.CLOSED'
  }
};
